'use es6';

import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import wrapWithMarks from './wrapWithMarks';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultLoadingComponent = () => /*#__PURE__*/_jsx(TFlex, {
  justify: "start",
  position: "relative",
  children: /*#__PURE__*/_jsx(LoadingSpinner, {
    size: "xs"
  })
});
export function makeAsyncActions({
  cardType,
  loader,
  LoadingComponent = DefaultLoadingComponent
}) {
  const actualLoader = cardType ? wrapWithMarks(cardType, 'actions', loader) : loader;
  return Loadable({
    loader: actualLoader,
    LoadingComponent
  });
}